import {
  CASAMAPA_QUIZ_PROGRESS_TTL_MS,
  CASAMAPA_QUIZ_VERSION,
  createEmptyCasaMapaQuizAnswers,
} from "./casaMapaQuizConstants";

function storageKey(slug) {
  return `client-view:${String(slug || "").trim().toLowerCase()}:quiz-progress`;
}

function readJson(key) {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function writeJson(key, value) {
  if (typeof window === "undefined") {
    return;
  }
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* quota */
  }
}

export function isCasaMapaQuizProgressFresh(progress, now = Date.now()) {
  if (!progress?.updatedAt) {
    return false;
  }
  const updated = Date.parse(progress.updatedAt);
  if (!Number.isFinite(updated)) {
    return false;
  }
  return now - updated <= CASAMAPA_QUIZ_PROGRESS_TTL_MS;
}

export function loadCasaMapaQuizProgress(slug) {
  const raw = readJson(storageKey(slug));
  if (!raw || raw.version !== CASAMAPA_QUIZ_VERSION) {
    return null;
  }
  if (!isCasaMapaQuizProgressFresh(raw)) {
    clearCasaMapaQuizProgress(slug);
    return null;
  }
  return {
    version: CASAMAPA_QUIZ_VERSION,
    stepId: typeof raw.stepId === "string" ? raw.stepId : "listingType",
    answers: {
      ...createEmptyCasaMapaQuizAnswers(),
      ...(raw.answers && typeof raw.answers === "object" ? raw.answers : {}),
    },
    updatedAt: raw.updatedAt,
  };
}

export function saveCasaMapaQuizProgress(slug, { stepId, answers }) {
  const payload = {
    version: CASAMAPA_QUIZ_VERSION,
    stepId: stepId || "listingType",
    answers: {
      ...createEmptyCasaMapaQuizAnswers(),
      ...(answers && typeof answers === "object" ? answers : {}),
    },
    updatedAt: new Date().toISOString(),
  };
  writeJson(storageKey(slug), payload);
  return payload;
}

export function clearCasaMapaQuizProgress(slug) {
  if (typeof window === "undefined") {
    return;
  }
  try {
    localStorage.removeItem(storageKey(slug));
  } catch {
    /* ignore */
  }
}

/** Completed quiz snapshot for results page (short-lived session). */
export function saveCasaMapaQuizResult(slug, result) {
  writeJson(`client-view:${String(slug || "").trim().toLowerCase()}:quiz-result`, {
    version: CASAMAPA_QUIZ_VERSION,
    ...result,
    savedAt: new Date().toISOString(),
  });
}

export function loadCasaMapaQuizResult(slug) {
  const raw = readJson(`client-view:${String(slug || "").trim().toLowerCase()}:quiz-result`);
  if (!raw || raw.version !== CASAMAPA_QUIZ_VERSION) {
    return null;
  }
  return raw;
}

export function clearCasaMapaQuizResult(slug) {
  if (typeof window === "undefined") {
    return;
  }
  try {
    localStorage.removeItem(
      `client-view:${String(slug || "").trim().toLowerCase()}:quiz-result`
    );
  } catch {
    /* ignore */
  }
}
